import authHeader from "../../../helpers/auth-header";

const API_URL = process.env.VUE_APP_API_ENDPOINT;

export default {
  namespaced: true,
  state: {
    categories: []
  },

  mutations: {
    SET_CATEGORIES(state, list) {
      state.categories = list;
    },
    ADD_CATEGORY(state, item) {
      state.categories.push(item);
    },
    UPDATE_CATEGORY(state, item) {
      const i = state.categories.findIndex(c => c._id === item._id);
      if (i !== -1) state.categories.splice(i, 1, item);
    },
    REMOVE_CATEGORY(state, id) {
      state.categories = state.categories.filter(c => c._id !== id);
    }
  },
  actions: {
    async getCategories({ commit }, groupId) {
      const res = await fetch(
        `${API_URL}/lead/category-options?real_estate_group_id=${groupId}`,
        { headers: authHeader() }
      );
      const json = await res.json();
      commit("SET_CATEGORIES", json.data);
    },

    async createCategory({ commit }, payload) {
      const res = await fetch(`${API_URL}/lead/category-options`, {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      commit("ADD_CATEGORY", json.data);
    },

    async updateCategory({ commit }, payload) {
      const res = await fetch(
        `${API_URL}/lead/category-options/${payload._id}`,
        {
          method: "PUT",
          headers: authHeader(),
          body: JSON.stringify(payload)
        }
      );
      const json = await res.json();
      commit("UPDATE_CATEGORY", json.data);
    },

    async deleteCategory({ commit }, { id, groupId }) {
      const res = await fetch(
        `${API_URL}/lead/category-options/${id}?real_estate_group_id=${groupId}`,
        {
          method: "DELETE",
          headers: authHeader()
        }
      );
      const json = await res.json();
      commit("REMOVE_CATEGORY", json.data._id);
    },

    async reorderCategories(state, { groupId, items }) {
      await fetch(
        `${API_URL}/lead/category-options/reorder?real_estate_group_id=${groupId}`,
        {
          method: "PATCH",
          headers: authHeader(),
          body: JSON.stringify({ items })
        }
      );
    }
  }
};
